import React, { useState, useEffect } from 'react';
import { fournisseursAPI, API_URL } from '../../services/api';
import { 
  Users, Plus, X, Save, Edit, Trash2, Phone, Mail, 
  MapPin, Calendar, DollarSign, Package, TrendingUp, Eye, FileSpreadsheet
} from 'lucide-react';
import StockFournisseurDetaille from './StockFournisseurDetaille';

function Fournisseurs() {
  const [fournisseurs, setFournisseurs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [editingFournisseur, setEditingFournisseur] = useState(null);
  const [selectedFournisseur, setSelectedFournisseur] = useState(null);
  const [fournisseurDetails, setFournisseurDetails] = useState(null);
  const [saving, setSaving] = useState(false);
  const [showInactifs, setShowInactifs] = useState(false);
  const [produitsFournisseur, setProduitsFournisseur] = useState([]);
  const [showProduitsSection, setShowProduitsSection] = useState(false);
  const [showStockDetaille, setShowStockDetaille] = useState(false);
  const [fournisseurStockDetaille, setFournisseurStockDetaille] = useState(null);
  const [nouveauProduit, setNouveauProduit] = useState({
    type_produit: 'METAL',
    nom_produit: '',
    description: '',
    reference_fournisseur: '',
    prix_unitaire_indicatif: '',
    unite: 'g',
    delai_livraison_jours: '',
    quantite_minimum: '',
    notes: ''
  });

  const [formData, setFormData] = useState({
    nom: '',
    contact_nom: '',
    telephone: '',
    email: '',
    adresse: '',
    ville: '',
    pays: 'Maroc',
    conditions_paiement: 'Comptant',
    delai_livraison_jours: 7,
    notes: '',
    actif: true
  });

  useEffect(() => {
    loadFournisseurs();
  }, [showInactifs]);

  const loadFournisseurs = async () => {
    try {
      const response = await fournisseursAPI.getAll(!showInactifs);
      setFournisseurs(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const loadFournisseurDetails = async (id) => {
    try {
      const response = await fournisseursAPI.getOne(id);
      setFournisseurDetails(response.data);
      setSelectedFournisseur(response.data.fournisseur);
      setShowDetailModal(true);
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors du chargement des détails');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (editingFournisseur) {
        await fournisseursAPI.update(editingFournisseur.id, formData);
      } else {
        await fournisseursAPI.create(formData);
      }
      setShowModal(false);
      setEditingFournisseur(null);
      resetForm();
      await loadFournisseurs();
    } catch (error) {
      console.error('Erreur:', error);
      alert(error.response?.data?.error || 'Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = async (fournisseur) => {
    setEditingFournisseur(fournisseur);
    setFormData({
      nom: fournisseur.nom,
      contact_nom: fournisseur.contact_nom || '',
      telephone: fournisseur.telephone || '',
      email: fournisseur.email || '',
      adresse: fournisseur.adresse || '',
      ville: fournisseur.ville || '',
      pays: fournisseur.pays || 'Maroc',
      conditions_paiement: fournisseur.conditions_paiement || 'Comptant',
      delai_livraison_jours: fournisseur.delai_livraison_jours || 7,
      notes: fournisseur.notes || '',
      actif: fournisseur.actif
    });
    
    // Charger les produits du fournisseur
    try {
      const response = await fetch(`${API_URL}/fournisseurs/${fournisseur.id}/produits`);
      const data = await response.json();
      setProduitsFournisseur(Array.isArray(data) ? data : []);
      setShowProduitsSection(true);
    } catch (error) {
      console.error('Erreur chargement produits:', error);
      setProduitsFournisseur([]);
    }
    
    setShowModal(true);
  };

  const ajouterProduit = async () => {
    if (!editingFournisseur || !nouveauProduit.type_produit || !nouveauProduit.nom_produit) {
      alert('Veuillez remplir au moins le type et le nom du produit');
      return;
    }

    try {
      const response = await fetch(`${API_URL}/fournisseurs/${editingFournisseur.id}/produits`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nouveauProduit)
      });

      if (response.ok) {
        // Recharger les produits
        const prodResponse = await fetch(`${API_URL}/fournisseurs/${editingFournisseur.id}/produits`);
        const data = await prodResponse.json();
        setProduitsFournisseur(Array.isArray(data) ? data : []);
        
        // Réinitialiser le formulaire
        setNouveauProduit({
          type_produit: 'METAL',
          nom_produit: '',
          description: '',
          reference_fournisseur: '',
          prix_unitaire_indicatif: '',
          unite: 'g',
          delai_livraison_jours: '',
          quantite_minimum: '',
          notes: ''
        });
        
        alert('Produit ajouté avec succès !');
      } else {
        alert('Erreur lors de l\'ajout du produit');
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de l\'ajout du produit');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Supprimer ce fournisseur ?')) {
      try {
        await fournisseursAPI.delete(id);
        await loadFournisseurs();
      } catch (error) {
        alert('Erreur lors de la suppression');
      }
    }
  };

  const resetForm = () => {
    setFormData({
      nom: '',
      contact_nom: '',
      telephone: '',
      email: '',
      adresse: '',
      ville: '',
      pays: 'Maroc',
      conditions_paiement: 'Comptant',
      delai_livraison_jours: 7,
      notes: '',
      actif: true
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
        <h2 className="text-3xl font-bold text-gray-800 flex items-center space-x-3">
          <Users className="h-8 w-8 text-blue-600" />
          <span>Gestion des Fournisseurs</span>
        </h2>
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full sm:w-auto">
          <label className="flex items-center space-x-2 text-sm text-gray-600">
            <input
              type="checkbox"
              checked={showInactifs}
              onChange={(e) => setShowInactifs(e.target.checked)}
              className="rounded"
            />
            <span>Afficher inactifs</span>
          </label>
          <button
            onClick={() => {
              resetForm();
              setEditingFournisseur(null);
              setShowModal(true);
            }}
            className="w-full sm:w-auto bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-3 rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all flex items-center justify-center space-x-2 shadow-lg"
          >
            <Plus className="h-5 w-5" />
            <span>Nouveau fournisseur</span>
          </button>
        </div>
      </div>

      {/* Liste des fournisseurs */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {fournisseurs.map((fournisseur) => (
          <div key={fournisseur.id} className={`bg-white rounded-lg shadow-md overflow-hidden border-t-4 ${fournisseur.actif ? 'border-blue-500' : 'border-gray-400'}`}>
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-800 mb-1">{fournisseur.nom}</h3>
                  {fournisseur.contact_nom && (
                    <p className="text-sm text-gray-600">{fournisseur.contact_nom}</p>
                  )}
                  {!fournisseur.actif && (
                    <span className="inline-block mt-2 px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded">
                      Inactif
                    </span>
                  )}
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => {
                      setFournisseurStockDetaille(fournisseur);
                      setShowStockDetaille(true);
                    }}
                    className="p-2 text-purple-600 hover:bg-purple-50 rounded-lg transition-colors"
                    title="Voir stock détaillé (Excel)"
                  >
                    <FileSpreadsheet className="h-4 w-4" />
                  </button>
                  <button
                    onClick={() => loadFournisseurDetails(fournisseur.id)}
                    className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                    title="Voir détails"
                  >
                    <Eye className="h-4 w-4" />
                  </button>
                  <button
                    onClick={() => handleEdit(fournisseur)}
                    className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                  >
                    <Edit className="h-4 w-4" />
                  </button>
                  <button
                    onClick={() => handleDelete(fournisseur.id)}
                    className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              </div>

              <div className="space-y-2 text-sm">
                {fournisseur.telephone && (
                  <div className="flex items-center space-x-2 text-gray-600">
                    <Phone className="h-4 w-4" />
                    <span>{fournisseur.telephone}</span>
                  </div>
                )}
                {fournisseur.email && (
                  <div className="flex items-center space-x-2 text-gray-600">
                    <Mail className="h-4 w-4" />
                    <span className="truncate">{fournisseur.email}</span>
                  </div>
                )}
                {fournisseur.ville && (
                  <div className="flex items-center space-x-2 text-gray-600">
                    <MapPin className="h-4 w-4" />
                    <span>{fournisseur.ville}</span>
                  </div>
                )}
                <div className="flex items-center space-x-2 text-gray-600">
                  <Calendar className="h-4 w-4" />
                  <span>Délai: {fournisseur.delai_livraison_jours} jours</span>
                </div>
                <div className="flex items-center space-x-2 text-gray-600">
                  <DollarSign className="h-4 w-4" />
                  <span>{fournisseur.conditions_paiement}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal de création/édition */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 sm:p-4">
          <div className="bg-white rounded-t-2xl sm:rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-4 flex justify-between items-center">
              <div className="flex items-center space-x-3">
                <Users className="h-6 w-6" />
                <h3 className="text-xl font-bold">
                  {editingFournisseur ? 'Modifier le fournisseur' : 'Nouveau fournisseur'}
                </h3>
              </div>
              <button
                onClick={() => {
                  setShowModal(false);
                  setEditingFournisseur(null);
                  resetForm();
                }}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-colors"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nom du fournisseur *</label>
                  <input
                    type="text"
                    value={formData.nom}
                    onChange={(e) => setFormData({...formData, nom: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Personne de contact</label>
                  <input
                    type="text"
                    value={formData.contact_nom}
                    onChange={(e) => setFormData({...formData, contact_nom: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Téléphone</label>
                  <input
                    type="text"
                    value={formData.telephone}
                    onChange={(e) => setFormData({...formData, telephone: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Adresse</label>
                  <input
                    type="text"
                    value={formData.adresse}
                    onChange={(e) => setFormData({...formData, adresse: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ville</label>
                  <input
                    type="text"
                    value={formData.ville}
                    onChange={(e) => setFormData({...formData, ville: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Pays</label>
                  <input
                    type="text"
                    value={formData.pays}
                    onChange={(e) => setFormData({...formData, pays: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Conditions de paiement</label>
                  <select
                    value={formData.conditions_paiement}
                    onChange={(e) => setFormData({...formData, conditions_paiement: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="Comptant">Comptant</option>
                    <option value="30 jours">30 jours</option>
                    <option value="60 jours">60 jours</option>
                    <option value="90 jours">90 jours</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Délai de livraison (jours)</label>
                  <input
                    type="text" inputMode="decimal" onFocus={e => e.target.select()}
                    value={formData.delai_livraison_jours}
                    onChange={(e) => setFormData({...formData, delai_livraison_jours: parseInt(e.target.value)})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    min="1"
                  />
                </div>

                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
                  <textarea
                    value={formData.notes}
                    onChange={(e) => setFormData({...formData, notes: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    rows="3"
                  />
                </div>

                <div className="col-span-2 flex items-center space-x-2">
                  <input
                    type="checkbox"
                    id="actif"
                    checked={formData.actif}
                    onChange={(e) => setFormData({...formData, actif: e.target.checked})}
                    className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
                  />
                  <label htmlFor="actif" className="text-sm font-medium text-gray-700">
                    Fournisseur actif
                  </label>
                </div>
              </div>

              {/* Section Produits vendus par le fournisseur */}
              {editingFournisseur && showProduitsSection && (
                <div className="col-span-2 border-t pt-4 mt-4">
                  <h4 className="text-lg font-semibold mb-3 flex items-center">
                    <Package className="mr-2" />
                    Produits vendus par ce fournisseur
                  </h4>
                  
                  {/* Liste des produits existants */}
                  {produitsFournisseur.length > 0 && (
                    <div className="mb-4 space-y-2">
                      {produitsFournisseur.map((produit) => (
                        <div key={produit.id} className="bg-gray-50 p-3 rounded-lg flex justify-between items-center">
                          <div>
                            <p className="font-medium">{produit.nom_produit}</p>
                            <p className="text-sm text-gray-600">
                              Type: {produit.type_produit} | 
                              {produit.prix_unitaire_indicatif && ` Prix: ${produit.prix_unitaire_indicatif} DH/${produit.unite}`}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Formulaire d'ajout de produit */}
                  <div className="bg-blue-50 p-4 rounded-lg space-y-3">
                    <h5 className="font-medium text-blue-900">Ajouter un nouveau produit</h5>
                    
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Type *</label>
                        <select
                          value={nouveauProduit.type_produit}
                          onChange={(e) => setNouveauProduit({...nouveauProduit, type_produit: e.target.value})}
                          className="w-full px-3 py-2 border rounded-lg"
                        >
                          <option value="METAL">Métal (Or, Argent)</option>
                          <option value="PIERRE">Pierre précieuse</option>
                          <option value="CHAINE">Chaîne</option>
                          <option value="MOUSQUETON">Mousqueton</option>
                          <option value="COMPOSANT">Composant</option>
                          <option value="BIJOU">Bijou fini</option>
                          <option value="AUTRE">Autre</option>
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Nom du produit *</label>
                        <input
                          type="text"
                          value={nouveauProduit.nom_produit}
                          onChange={(e) => setNouveauProduit({...nouveauProduit, nom_produit: e.target.value})}
                          className="w-full px-3 py-2 border rounded-lg"
                          placeholder="Ex: Diamant 1ct, Or 18K, etc."
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Prix indicatif</label>
                        <input
                          type="text" inputMode="decimal" onFocus={e => e.target.select()}
                          step="0.01"
                          value={nouveauProduit.prix_unitaire_indicatif}
                          onChange={(e) => setNouveauProduit({...nouveauProduit, prix_unitaire_indicatif: e.target.value})}
                          className="w-full px-3 py-2 border rounded-lg"
                          placeholder="Prix unitaire"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Unité</label>
                        <select
                          value={nouveauProduit.unite}
                          onChange={(e) => setNouveauProduit({...nouveauProduit, unite: e.target.value})}
                          className="w-full px-3 py-2 border rounded-lg"
                        >
                          <option value="g">Gramme (g)</option>
                          <option value="carat">Carat</option>
                          <option value="pièce">Pièce</option>
                          <option value="unité">Unité</option>
                        </select>
                      </div>

                      <div className="col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                        <input
                          type="text"
                          value={nouveauProduit.description}
                          onChange={(e) => setNouveauProduit({...nouveauProduit, description: e.target.value})}
                          className="w-full px-3 py-2 border rounded-lg"
                          placeholder="Description du produit"
                        />
                      </div>
                    </div>

                    <button
                      type="button"
                      onClick={ajouterProduit}
                      className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center space-x-2"
                    >
                      <Plus size={18} />
                      <span>Ajouter ce produit</span>
                    </button>
                  </div>
                </div>
              )}

              <div className="flex justify-end space-x-3 pt-4 border-t">
                <button
                  type="button"
                  onClick={() => {
                    setShowModal(false);
                    setEditingFournisseur(null);
                    setShowProduitsSection(false);
                    setProduitsFournisseur([]);
                    resetForm();
                  }}
                  className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={saving}
                  className="px-6 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all flex items-center space-x-2 disabled:opacity-50"
                >
                  <Save className="h-5 w-5" />
                  <span>{saving ? 'Enregistrement...' : 'Enregistrer'}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de détails */}
      {showDetailModal && fournisseurDetails && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 sm:p-4">
          <div className="bg-white rounded-t-2xl sm:rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-4 flex justify-between items-center">
              <h3 className="text-xl font-bold">{selectedFournisseur.nom}</h3>
              <button
                onClick={() => setShowDetailModal(false)}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-colors"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="p-6 space-y-6">
              {/* Statistiques */}
              {fournisseurDetails.statistiques && (
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div className="bg-blue-50 rounded-lg p-4">
                    <div className="flex items-center space-x-2 text-blue-600 mb-2">
                      <Package className="h-5 w-5" />
                      <span className="text-sm font-medium">Commandes</span>
                    </div>
                    <div className="text-2xl font-bold text-gray-800">
                      {fournisseurDetails.statistiques.nb_commandes || 0}
                    </div>
                  </div>
                  <div className="bg-green-50 rounded-lg p-4">
                    <div className="flex items-center space-x-2 text-green-600 mb-2">
                      <DollarSign className="h-5 w-5" />
                      <span className="text-sm font-medium">Total achats</span>
                    </div>
                    <div className="text-2xl font-bold text-gray-800">
                      {parseFloat(fournisseurDetails.statistiques.total_achats || 0).toLocaleString()} DH
                    </div>
                  </div>
                  <div className="bg-purple-50 rounded-lg p-4">
                    <div className="flex items-center space-x-2 text-purple-600 mb-2">
                      <TrendingUp className="h-5 w-5" />
                      <span className="text-sm font-medium">Total payé</span>
                    </div>
                    <div className="text-2xl font-bold text-gray-800">
                      {parseFloat(fournisseurDetails.statistiques.total_paye || 0).toLocaleString()} DH
                    </div>
                  </div>
                </div>
              )}

              {/* Dernières commandes */}
              {fournisseurDetails.dernieres_commandes && fournisseurDetails.dernieres_commandes.length > 0 && (
                <div>
                  <h4 className="text-lg font-bold text-gray-800 mb-3">Dernières commandes</h4>
                  <div className="space-y-2">
                    {fournisseurDetails.dernieres_commandes.map((commande) => (
                      <div key={commande.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                        <div>
                          <div className="font-semibold text-gray-800">{commande.numero_commande}</div>
                          <div className="text-sm text-gray-600">
                            {new Date(commande.date_commande).toLocaleDateString('fr-FR')}
                          </div>
                        </div>
                        <div className="text-right">
                          <div className="font-bold text-gray-800">
                            {parseFloat(commande.montant_total).toLocaleString()} DH
                          </div>
                          <div className={`text-xs px-2 py-1 rounded ${
                            commande.statut === 'recu' ? 'bg-green-100 text-green-800' :
                            commande.statut === 'commande' ? 'bg-blue-100 text-blue-800' :
                            'bg-gray-100 text-gray-800'
                          }`}>
                            {commande.statut}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Stock Détaillé */}
      {showStockDetaille && fournisseurStockDetaille && (
        <StockFournisseurDetaille
          fournisseur={fournisseurStockDetaille}
          onClose={() => {
            setShowStockDetaille(false);
            setFournisseurStockDetaille(null);
          }}
        />
      )}
    </div>
  );
}

export default Fournisseurs;
